export const getInitialState = () => ({
    travelPurpose: "leisure"
});
